import { render, staticRenderFns } from "./normal-preview-mobiles.vue?vue&type=template&id=86604e82&scoped=true"
import script from "./normal-preview-mobiles.vue?vue&type=script&lang=js"
export * from "./normal-preview-mobiles.vue?vue&type=script&lang=js"
import style0 from "./normal-preview-mobiles.vue?vue&type=style&index=0&id=86604e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86604e82",
  null
  
)

export default component.exports